export var IncentiveOfferType;
(function (IncentiveOfferType) {
    IncentiveOfferType["STACKABLE_REBATE"] = "StackableRebate";
    IncentiveOfferType["NON_STACKABLE_REBATE"] = "NonStackableRebate";
    IncentiveOfferType["GOV_INCENTIVE"] = "GovIncentive";
})(IncentiveOfferType || (IncentiveOfferType = {}));
export const OFFER_TYPE_PERCENT = 'percent';
export const OFFER_TYPE_DOLLAR = 'dollar';
export const OFFER_TYPE_PERCENT_DOLLAR = 'percent_dollar';
export const OFFER_TYPES = [OFFER_TYPE_PERCENT, OFFER_TYPE_DOLLAR, OFFER_TYPE_PERCENT_DOLLAR];
export const LOYALTY_OFFER_TYPES_SET = new Set(OFFER_TYPES);
